import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateFreeCodes } from '@store/slice/paymentSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListFreeCodes = () => {
  const { freeCodes } = useSelector(state => state.payment)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation(['common'], 'payment')

  const dataDistricts = { nodes: [] }
  if (freeCodes) {
    dataDistricts.nodes = Object.values(freeCodes)
  }

  const removeFreeCode = freeCode => {
    const { id, links } = freeCode
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const freeCode = freeCodes[id]
        const freeCodesList = { ...freeCodes }
        delete freeCodesList[id]
        dispatch(updateFreeCodes({ ...freeCodesList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: freeCode.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/free-codes`, response => {
      const { code, freeCodes } = response
      if (code === 200) {
        dispatch(updateFreeCodes(freeCodes))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('freeCode'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('payment:titles.free_codes_list')}</h2>
      {null !== freeCodes && dataDistricts.nodes.length
        ? <>
          <Table data={dataDistricts} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Name')}</HeaderCell>
                    <HeaderCell>{t('table.Portion')}</HeaderCell>
                    <HeaderCell>{t('table.Code')}</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.name}</Cell>
                      <Cell>{item.portion}%</Cell>
                      <Cell>{item.code}</Cell>
                      <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('freeCode', '', item)
                          }
                        ]} />
                        {deleteButton(item, item.name, removeFreeCode)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListFreeCodes